import { render, staticRenderFns } from "./PluginVariables.vue?vue&type=template&id=20aaf899&scoped=true"
import script from "./PluginVariables.vue?vue&type=script&lang=js"
export * from "./PluginVariables.vue?vue&type=script&lang=js"
import style0 from "./PluginVariables.vue?vue&type=style&index=0&id=20aaf899&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aaf899",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20aaf899')) {
      api.createRecord('20aaf899', component.options)
    } else {
      api.reload('20aaf899', component.options)
    }
    module.hot.accept("./PluginVariables.vue?vue&type=template&id=20aaf899&scoped=true", function () {
      api.rerender('20aaf899', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/PluginVariables.vue"
export default component.exports